import './App.css';
import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PocketBase from 'pocketbase';
import { Image } from 'lucide-react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import SearchBox from './SearchBox';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1C1C1C',
    },
    secondary: {
      main: '#C03221',
    },
  },
});

const URL = 'https://scraper.agrya.hu';
const pb = new PocketBase(URL);


function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [rows, setRows] = useState(null);
  const [ modalImage, setModalImage ] = useState(null);
  pb.autoCancellation(false); // disable auto cancellation of requests on page unload
  const [ error, setError ] = useState(null);

    useEffect(() => {
      if (pb.authStore.isValid) {
        setIsLoggedIn(true);
      }
    }, []);

    useEffect(() => {
      if (isLoggedIn) {
        const fetchData = async () => {
          console.log("Fetching data...");
          try {
            const records = await pb.collection('results').getList(1, 50, {
              sort: '-created',
              expand: 'tag',
            });
            console.log("Data fetched successfully:", records);
            setRows(records);
          } catch (err) {
            console.log(err);
            setError("Hiba történt az adatok lekérése közben.");
          }
        };
        fetchData();
      }
    }, [isLoggedIn]);

    function fetchMoreData() {
      if (rows && rows.page < rows.totalPages) {
        const fetchData = async () => {
          console.log("Fetching more data...");
          try {
            const records = await pb.collection('results').getList(rows.page + 1, 50, {
              sort: '-created',
              expand: 'tag',
            });
            console.log("More data fetched successfully:", records);
            setRows((prevRows) => ({
              ...records,
              items: [...prevRows.items, ...records.items],
            }));
          } catch (err) {
            console.log(err);
            setError("Hiba történt az adatok lekérése közben.");
          }
        };
        fetchData();
      }
    }

    async function handleLogin() {
      if (pb.authStore.isValid) {
        setIsLoggedIn(true);
      }
      pb.authStore.clear();
     try {
    await pb.collection("users").authWithOAuth2({
      provider: "oidc2",
    });
    setIsLoggedIn(true);
  } catch (err) {
    console.log(err);
    console.log(err.response);
    console.log(err.data);
  }
  }

  function handleInteresting(id) {
    const record = rows.items.find((item) => item.id === id);
    const updatedInteresting = !record.interesting;

    pb.collection('results').update(id, { interesting: updatedInteresting })
      .then((updatedRecord) => {
        updatedRecord.expand = record.expand; // Preserve the expand property
        setRows((prevRows) => {
          const updatedItems = prevRows.items.map((item) =>
            item.id === id ? updatedRecord : item
          );
          return { ...prevRows, items: updatedItems };
        });
      })
      .catch((err) => {
        console.log(err);
        setError("Hiba történt az érdekes mező frissítése közben.");
      });
  }

  function colorize(str) {
    for (var i = 0, hash = 0; i < str.length; hash = str.charCodeAt(i++) + ((hash << 5) - hash));
    const color = Math.floor(Math.abs((Math.sin(hash) * 10000) % 1 * 16777216)).toString(16);
    return '#' + Array(6 - color.length + 1).join('0') + color
  }

  function getBrightness(hexColor) {
    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  return (
    <ThemeProvider theme={theme}>
      <Snackbar
        open={!!error}
        onClose={() => setError(null)}
        message={error}
      />
      <Modal open={modalImage !== null} onClose={() => setModalImage(null)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box>
          <div style={{ width: '100%', height: '70vh', overflowY: 'auto', marginTop: '8px' }}>
          <img src={modalImage} alt="Képernyőkép" style={{ width: '100%', marginTop: '16px' }} />
          </div>
        </Box>
      </Modal>
      <AppBar position="static" style={{ backgroundColor: "#1C1C1C"}}>
        <Typography variant="h5" style={{ marginLeft: "16px", marginTop: "8px", marginBottom: "8px", textAlign: "left" }}>
          Hírek
        </Typography>
      </AppBar>
      <Button variant="contained" color="secondary" style={{ display: isLoggedIn ? "none" : "block", marginLeft: "auto", marginRight: "auto", marginTop: "40vh" }} onClick={() => handleLogin()}>
      SSO Bejelentkezés
      </Button>
    <div style={{ display: isLoggedIn ? "block" : "none" }}>
       <SearchBox pb={pb} URL={URL} setRows={setRows} setError={setError} rows={rows} />
       <TableContainer component={Paper} style={{ marginTop: "20px", marginBottom: "20px", width: "98%", marginLeft: "auto", marginRight: "auto" }}>
       <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Cím</TableCell>
            <TableCell align="right">Link</TableCell>
            <TableCell align="right">Képernyőkép</TableCell>
            <TableCell align="right">Érdekes</TableCell>
            <TableCell align="right">Tagek</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { rows && rows.items.map((row, index) => (
            //Check whether this is the last record of the day (they are in order and if so add a thick border to the bottom of the row)
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 }, borderBottom: (index === rows.items.length - 1 || (index < rows.items.length - 1 && new Date(row.created).toDateString() !== new Date(rows.items[index + 1].created).toDateString())) ? '2px solid #1C1C1C' : '1px solid rgba(224, 224, 224, 1)' }}
            >
              <TableCell component="th" scope="row">
                {row.browserTitle ? row.browserTitle : row.pageLink}
              </TableCell>
              <TableCell align="right"><Button variant="contained" color="secondary" href={row.pageLink} target="_blank">Megnyitás</Button></TableCell>
              <TableCell align="right"><Button variant="outlined" color="secondary" onClick={() => setModalImage(`${URL}/api/files/results/${row.id}/${row.screenShot}`)} startIcon={<Image />} disabled={row.screenShot === null || row.screenShot === ""}
              >Kép</Button></TableCell>
              <TableCell align="right"><Button variant='outlined' onClick={() => handleInteresting(row.id)} color={row.interesting ? "secondary" : "primary"}>{row.interesting ? "Igen" : "Nem"}</Button></TableCell>
              { row && row.expand && row.expand.tag && row.expand.tag.length > 0 ? (
              <TableCell align="right">
                {row.expand.tag ? row.expand.tag.map((tag) => { return (
                  <Chip key={tag.id} label={tag.display} sx={{ backgroundColor: colorize(tag.display), color: getBrightness(colorize(tag.display)) > 128 ? '#000000' : '#FFFFFF', marginRight: "4px", marginBottom: { lg: "0px", xs: "4px", md: "4px", xl: "0px" }}} />
                )}
               ) : "Nincs"}
              </TableCell>
              ) : (
                <TableCell align="right">Nincs</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
    <Button variant="contained" color="secondary" style={{ display: isLoggedIn ? "block" : "none", marginLeft: "auto", marginRight: "auto", marginBottom: "20px" }} onClick={fetchMoreData}>
      Több betöltése
    </Button>
    </ThemeProvider>
  );
}

export default App;
